export class ImgConstants {
  public EPRINT_LOGO = "./assets/images/eprintit-logo-white-slogan.svg";
}
